import { render, staticRenderFns } from "./myPromise.vue?vue&type=template&id=022b8ddc&scoped=true"
import script from "./myPromise.vue?vue&type=script&lang=js"
export * from "./myPromise.vue?vue&type=script&lang=js"
import style0 from "./myPromise.vue?vue&type=style&index=0&id=022b8ddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022b8ddc",
  null
  
)

export default component.exports